<template>
  <div>
    <navlist :navlist="about" :show='false' />
    <div class="layout">
      <div class="title">
        <h1>
          社区
          <br />特色
        </h1>
        <h2>{{local.name}}</h2>
      </div>
      <div class="main">
         <div v-html="content"></div>
         <div class="about-img">
            <swiper :swiperSlides='arrimg'/>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import navlist from "../components/nav";
import swiper from '../components/swiper'
import {getArtAndAlbum} from '../api/index'
export default {
  name:'charactdetail',
  components: {
    navlist, swiper
  },
  data() {
    return {
      about: [
        {
          path: "/character",
          name: "社区特色"
        }
      ],
      list:[
          {
          path: "/green",
          name: "三融"
        },
          {
          path: "/red",
          name: "三爱"
        },
          {
          path: "/blue",
          name: "三服务"
        }
      ],
      local: {},
      content:'',
      action: this.$route.params.id,
      arrimg:[]
    };
  },
  created() {
    this.showlocal(this.$route);
    this.getContent()
  },
  watch: {
    $route(to) {
      this.showlocal(to);
    }
  },
  methods: {
    showlocal(to) {
      const local = this.list.filter(item => {
        if(item.path.indexOf(to.params.id)>=0){
          return item
        }
      });
      this.local = local[0];
    
    },
    async getContent(){
      let {action} =this
      let {data} = await getArtAndAlbum({action})
      this.content = data.data.content
      this.arrimg = data.album.map(item=>{
        const obj={}
        obj['src']= "/static/uploads/" + item.img
        return obj
      })
    }
  }
};
</script>

<style>
.width {
  width: 1380px;
  margin-top: 20px !important;
}
</style>